// extracted by mini-css-extract-plugin
export default {"primaryItem":"_2ab777d6","primaryLink":"_eb014783","primaryImage":"_49ffb344","productItems":"_7a43d942","fullHeight":"_674575a3","shimmerLoadingBackground":"_bfe4ea62"};